import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';

import Icon from '_components/atomic/Icon';

const { colors, fontSizes, spaces } = theme;

const StyledPaginate = styled(ReactPaginate)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;

  li {
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 44px;
      padding-top: ${spaces.smallX + 2}px;
      padding-bottom: ${spaces.smallX + 2}px;
      padding-left: ${spaces.smallX + 2}px;
      padding-right: ${spaces.smallX + 2}px;
      margin-left: ${spaces.small2X}px;
      margin-right: ${spaces.small2X}px;
      font-family: 'Aeonik';
      font-size: ${fontSizes.regular}px;
      font-style: normal;
      font-weight: 500;
      background-color: ${colors.gray[100]};

      &:not([href]):not([class]) {
        color: ${colors.gray[500]};
      }

      &:hover,
      &:not([href]):not([class]):hover {
        color: ${colors.indigo[500]};
        background-color: ${colors.indigo[100]};

        svg {
          path {
            fill: ${colors.indigo[500]};
          }
        }
      }
    }

    &.selected {
      a {
        background-color: ${colors.indigo[500]};

        &:not([href]):not([class]) {
          color: ${colors.white};
        }

        &:not([href]):not([class]):hover {
          background-color: ${colors.indigo[500]};
        }
      }
    }

    &.previous {
      a {
        margin-right: ${spaces.regular}px;
        margin-left: 0;
      }
    }

    &.next {
      a {
        margin-left: ${spaces.regular}px;
        margin-right: 0;
      }
    }

    &.disabled {
      a {
        pointer-events: none;
      }
    }
  }
`;

const Paginate = ({ pageCount, currentPageIndex, onPageChange }) => {
  const handlePageChange = useCallback(
    (data) => {
      onPageChange(data.selected);
    },
    [onPageChange]
  );

  return (
    <StyledPaginate
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      previousLabel={
        <Icon alias={ICONS_ALIASES.arrowLeftSquared} color={colors.gray[500]} />
      }
      nextLabel={
        <Icon
          alias={ICONS_ALIASES.arrowRightSquared}
          color={colors.gray[500]}
        />
      }
      pageCount={pageCount}
      forcePage={currentPageIndex}
      onPageChange={handlePageChange}
    />
  );
};

Paginate.propTypes = {
  pageCount: PropTypes.number,
  currentPageIndex: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default Paginate;
